export default {
  appliesToAllReports: 'Dotyczy wszystkich raportów',
};
